<script lang="ts" setup>
import router from "@/router/router.ts";
import {defineProps} from "vue";
import type {AbstractEntity} from "@/domain/entity/AbstractEntity.ts";
import {SyncState} from "@/domain/type/synchro.type.ts";

const props = defineProps<{
  entity: AbstractEntity
}>();

function goToFusion() {
  const url = router.resolve(props.entity.fusionLink())

  window.open(url.fullPath, '_blank');
}
</script>

<template>
  <v-btn v-if="entity.state === SyncState.DIFF" style="width:180px;" @click="goToFusion">Vérifier</v-btn>
  <div v-else-if="entity.state === SyncState.OK" class="d-flex justify-center align-center" style="width:180px;">
    <v-icon color="success" size="35px" @click="goToFusion">mdi-check-circle</v-icon>
  </div>
</template>
